/**
 * API utility functions for making authenticated requests
 */

/**
 * Get CSRF token from cookies
 */
export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

/**
 * Get default headers for API requests
 */
export function getApiHeaders(additionalHeaders = {}) {
  const csrftoken = getCookie('csrftoken');
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    ...(csrftoken && { 'X-CSRFToken': csrftoken }),
    ...additionalHeaders,
  };
}

/**
 * Create axios config for API requests
 */
export function getApiConfig(additionalHeaders = {}) {
  return {
    withCredentials: true,
    headers: getApiHeaders(additionalHeaders),
  };
}

